<script>
  import data from '$lib/data/sales_data.json';
  import { scaleBand, scaleLinear } from 'd3-scale';
  import { max } from 'd3-array';
  import { line, curveBasis } from 'd3-shape';
  import AxisBottom from './AxisBottomBandV5.svelte';
  import AxisLeft from './AxisLeftV5.svelte';
  import AxisRight from './AxisRightV5.svelte';
  import Labels from './Labels.svelte';

  // State variables
  let width = $state(400); // width will be set by the clientWidth
  const height = 350;
  const margin = { top: 40, right: 30, bottom: 20, left: 50 };

  // Computed values
  let xScale = $derived(
    data && width
      ? scaleBand()
          .domain(data.map((d) => d.month))
          .range([margin.left, width - margin.right])
          .padding(0.1)
      : null
  );

  let yScale1 = $derived(
    data && width
      ? scaleLinear()
          .domain([0, max(data, (d) => d.sales)])
          .range([height - margin.bottom, margin.top])
      : null
  );

  let yScale2 = $derived(
    data && width
      ? scaleLinear()
          .domain([0, max(data, (d) => d.profit)])
          .range([height - margin.bottom, margin.top])
      : null
  );

  let linePath = $derived(
    xScale && yScale2
      ? line()
          .x((d) => xScale(d.month) + xScale.bandwidth() / 2)
          .y((d) => yScale2(d.profit))
          .curve(curveBasis)
      : null
  );
</script>

<div class="wrapper" bind:clientWidth={width}>
  {#if data && width && xScale && yScale1 && yScale2 && linePath}
    <svg
      width={width + margin.left + margin.right}
      height={height + margin.top + margin.bottom}>
      <AxisBottom
        {width}
        {height}
        {margin}
        {xScale}
        format={(d) => d.slice(0, 3)}
        filterFunc={(d, i) => i % 3 === 0} />
      <AxisLeft {width} {height} {margin} yScale={yScale1} />
      <Labels
        labelfory={true}
        {width}
        {height}
        {margin}
        yoffset={-15}
        xoffset={0}
        label={'$ Sales'}
        fillColor="steelblue" />
      <AxisRight {width} {margin} yScale={yScale2} />
      <Labels
        labelfory={true}
        {width}
        {height}
        {margin}
        yoffset={-15}
        xoffset={width - 28}
        label={'$ Profits'}
        fillColor="red" />

      {#each data as d}
        <rect
          x={xScale(d.month)}
          y={yScale1(d.sales)}
          width={xScale.bandwidth()}
          height={yScale1(0) - yScale1(d.sales)}
          fill="steelblue" />
      {/each}

      <path d={linePath(data)} fill="none" stroke="red" stroke-width="2" />
    </svg>
  {/if}
</div>
